import { html } from 'htm/preact';

const Eyebrow = ({ text }) => {
  return html`
    <div class="px-3 py-1.5 font-serif text-sm text-center text-nowrap text-white bg-black rounded-4xl">${text}</div>
  `;
};

export default Eyebrow;
